









import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "FieldWarnMessage",
  props: {
    message: {
      type: String,
      default: ""
    }
  }
});
